<template>
    <div>
        <div class="alert-warning">
            <span v-for="failureMessage in failureMessages" :key="failureMessage.key">
                {{failureMessage.value}}
            </span>
        </div>
        <div v-if="!externalUser">
            <RegisterPanel :userModel="uservalues" :sourceModel="sourceValues" :allowEmailEdit="false" :title="'Complete Account Registration'" @postForm="postForm"></RegisterPanel>
        </div>
        <div v-if="externalUser">
            <ExternalRegisterPanel :userModel="uservalues" :sourceModel="sourceValues" :allowEmailEdit="false" :title="'Complete Account Registration'" @postForm="postForm"></ExternalRegisterPanel>
        </div>
        <LicenseModal></LicenseModal>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapState } from 'vuex'
    import accountApiClient from '@/services/apiServices/accountApiClient.js'
    import RegisterPanel from '@/components/register/RegisterPanel.vue'
    import ExternalRegisterPanel from '@/components/register/ExternalRegisterPanel.vue'
    import LicenseModal from '@/components/terms/LicenseModal.vue'

    export default {
        name: 'CompleteRegister',
        components: {
            RegisterPanel,
            ExternalRegisterPanel,
            LicenseModal
        },
        data() {
            return {
                failureMessages: [""],
                uservalues: {
                    email: "",
                    company: "",
                    firstname: "",
                    lastname: "",
                    cadTool: "",
                    industryId: "",
                    countryId: "",
                    password: "",
                    confirmpassword: "",
                    showpassword: false,
                    toc: false,
                    news: false
                },
                sourceValues: {
                    populated: false,
                    industries: [],
                    countries: [],
                    initialcountry: "",
                    cadTools: [],
                    tocconsent: null
                }
            }
        },
        computed: {
            ...mapGetters('oidcStore', [
                'oidcUser'
            ]),
            ...mapState({
                backLink: state => state.navigation.backLink,
                returnUrl: state => state.navigation.returnUrl
            }),
            externalUser: function () {
                if (this.oidcUser.amr.includes('external'))
                    return true;
                return false;
            },
        },
        methods: {
            ...mapActions('oidcStore', [
                'signOutOidcSilent'
            ]),
            getCModel: async function () {
                var registerValue = await accountApiClient.GetRegisterModel();
                if (registerValue.status == 200) {
                    this.sourceValues = {
                        industries: registerValue.data.industries,
                        countries: registerValue.data.countries,
                        initialcountry: registerValue.data.countryId,
                        cadTools: registerValue.data.cadTools,
                        tocconsent: registerValue.data.tocConsent,
                        populated: true
                    }
                } else {
                    this.failureMessages = ["Server Interruption"]
                }
            },
            getCUser: async function () {
                var registerContent = await accountApiClient.GetCompleteModel();
                if (registerContent.status == 200) {
                    this.uservalues = {
                        email: registerContent.data.content.email,
                        company: registerContent.data.content.company,
                        firstname: registerContent.data.content.firstName,
                        lastname: registerContent.data.content.lastName,
                        cadTool: registerContent.data.content.cadTool.toString(),
                        industryId: registerContent.data.content.industryId.toString(),
                        countryId: registerContent.data.content.countryId.toString(),
                        password: "",
                        confirmpassword: "",
                        showpassword: false,
                        toc: false,
                        news: false
                    };
                } else {
                    this.failureMessages = ["Server Interruption"]
                }
            },
            postForm: async function (evt, registerModel) {
                var postResult = null;
                if (!this.externalUser) {
                    postResult = await accountApiClient.PostComplete(registerModel);
                } else {
                    //delete registerModel.password;
                    //delete registerModel.confirmpassword;
                    //delete registerModel.showpassword;
                    postResult = await accountApiClient.PostExternalComplete(registerModel);
                }
                if (postResult.status == 200) {
                    if (postResult.data.success) {
                        this.$store.dispatch('gtmConfirmRegistration');
                        this.$store.commit('SET_USERCONFIRMED');
                        if (this.backLink != "")
                            this.$store.commit('SET_RETURNURL', this.backLink);
                        else if (postResult.data.returnUrl != "")
                            this.$store.commit('SET_RETURNURL', postResult.data.returnUrl);
                        else
                            this.$store.commit('SET_RETURNURL', "/" + this.$route.params.instance);
                        this.$router.push({ name: "CompleteConfirmation" });
                    } else {
                        this.failureMessages = postResult.data.errors;
                    }
                } else {
                    this.failureMessages = ["Server Interruption"]
                }
            },
            signOut: function () {
                this.signOutOidcSilent();
                this.$store.commit('SIGN_OUT');
                this.$store.commit('CANCEL_EXPORT');
            },
        },
        beforeMount: async function () {
            await this.$router.isReady();
            await this.getCModel();
            await this.getCUser();
        }
    }
</script>

<style scoped>
</style>